"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Private = exports.Route = exports.Router = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/filter"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/map"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/reduce"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _auth = require("@redwoodjs/auth");

var _internal = require("./internal");

var _splashPage = require("./splash-page");

// The guts of the router implementation.
const Route = () => {
  return null;
};

exports.Route = Route;

/**
 * `Routes` nested in `Private` require authentication.
 * When a user is not authenticated and attempts to visit this route they will be
 * redirected to `unauthenticated` route.
 */
const Private = () => {
  return null;
};

exports.Private = Private;

const PrivatePageLoader = ({
  useAuth,
  unauthenticatedRoute,
  role,
  whileLoading = () => null,
  children
}) => {
  const {
    loading,
    isAuthenticated,
    hasRole
  } = useAuth();

  if (loading) {
    return whileLoading();
  }

  if (isAuthenticated && !role || isAuthenticated && role && hasRole(role)) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children || null);
  }

  const currentLocation = window.location.pathname + encodeURIComponent(window.location.search);
  return /*#__PURE__*/_react.default.createElement(_internal.Redirect, {
    to: `${unauthenticatedRoute()}?redirectTo=${currentLocation}`
  });
};

const Router = props => /*#__PURE__*/_react.default.createElement(_internal.Location, null, locationContext => /*#__PURE__*/_react.default.createElement(RouterImpl, (0, _extends2.default)({}, locationContext, props)));

exports.Router = Router;

function isSpec(specOrPage) {
  return specOrPage.loader !== undefined;
}

/**
 * Pages can be imported automatically or manually. Automatic imports are actually
 * objects and take the following form (which we call a 'spec'):
 *
 *   const WhateverPage = {
 *     name: 'WhateverPage',
 *     loader: () => import('src/pages/WhateverPage')
 *   }
 *
 * Manual imports simply load the page:
 *
 *   import WhateverPage from 'src/pages/WhateverPage'
 *
 * Before passing a "page" to the PageLoader, we will normalize the manually
 * imported version into a spec. */
const normalizePage = specOrPage => {
  if (isSpec(specOrPage)) {
    // Already a spec, just return it.
    return specOrPage;
  } // Wrap the Page in a fresh spec, and put it in a promise to emulate
  // an async module import.


  return {
    name: specOrPage.name,
    loader: async () => ({
      default: specOrPage
    })
  };
};

const DEFAULT_PAGE_LOADING_DELAY = 1000; // milliseconds

const Loaders = ({
  allParams,
  Page,
  pageLoadingDelay
}) => {
  return /*#__PURE__*/_react.default.createElement(_internal.PageLoader, {
    spec: normalizePage(Page),
    delay: pageLoadingDelay,
    params: allParams
  });
};

function isReactElement(element) {
  return element.type !== undefined;
}

const RouterImpl = ({
  pathname,
  search,
  paramTypes,
  pageLoadingDelay = DEFAULT_PAGE_LOADING_DELAY,
  children,
  useAuth = _auth.useAuth
}) => {
  const routes = _react.default.useMemo(() => {
    var _context, _context2, _context3, _context4, _context8, _context9;

    // Find `Private` components, mark their children `Route` components as private,
    // and merge them into a single array.
    const privateRoutes = (0, _reduce.default)(_context = (0, _map.default)(_context2 = (0, _filter.default)(_context3 = (0, _filter.default)(_context4 = _react.default.Children.toArray(children)).call(_context4, isReactElement)).call(_context3, child => child.type === Private)).call(_context2, privateElement => {
      var _context5, _context6, _context7;

      // Set `Route` props
      const {
        unauthenticated,
        role,
        children
      } = privateElement.props;
      return (0, _map.default)(_context5 = (0, _filter.default)(_context6 = (0, _filter.default)(_context7 = _react.default.Children.toArray(children) // Make sure only valid routes are considered
      ).call(_context7, isReactElement)).call(_context6, route => route.type === Route)).call(_context5, route => /*#__PURE__*/_react.default.cloneElement(route, {
        private: true,
        unauthenticatedRedirect: unauthenticated,
        role: role
      }));
    })).call(_context, (a, b) => (0, _concat.default)(a).call(a, b), []) || [];
    const routes = [...privateRoutes, ...(0, _filter.default)(_context8 = (0, _filter.default)(_context9 = _react.default.Children.toArray(children)).call(_context9, isReactElement)).call(_context8, child => child.type === Route)];
    return routes;
  }, [children]);

  const namedRoutes = _react.default.useMemo(() => (0, _internal.mapNamedRoutes)(routes), [routes]);

  let NotFoundPage;

  for (const route of routes) {
    const {
      path,
      page: Page,
      redirect,
      notfound,
      private: privateRoute,
      unauthenticatedRedirect,
      whileLoading
    } = route.props;

    if (notfound) {
      NotFoundPage = Page;
      continue;
    }

    const {
      match,
      params: pathParams
    } = (0, _internal.matchPath)(path, pathname, paramTypes);

    if (match) {
      const searchParams = (0, _internal.parseSearch)(search);
      const allParams = { ...pathParams,
        ...searchParams
      };

      if (redirect) {
        const newPath = (0, _internal.replaceParams)(redirect, pathParams);
        return /*#__PURE__*/_react.default.createElement(_internal.Redirect, {
          to: newPath
        });
      } else {
        if (privateRoute) {
          if (typeof useAuth === 'undefined') {
            throw new Error("You're using a private route, but `useAuth` is undefined. " + 'Have you created an AuthProvider, or passed in the ' + 'incorrect prop to `useAuth`?');
          }

          return /*#__PURE__*/_react.default.createElement(PrivatePageLoader, {
            useAuth: useAuth,
            unauthenticatedRoute: namedRoutes[unauthenticatedRedirect],
            whileLoading: whileLoading,
            role: route.props.role
          }, /*#__PURE__*/_react.default.createElement(Loaders, {
            allParams: allParams,
            Page: Page,
            pageLoadingDelay: pageLoadingDelay
          }));
        }

        return /*#__PURE__*/_react.default.createElement(Loaders, {
          allParams: allParams,
          Page: Page,
          pageLoadingDelay: pageLoadingDelay
        });
      }
    }
  } // If only the notfound page is specified, show the Redwood splash page.


  if (routes.length === 1 && NotFoundPage) {
    return /*#__PURE__*/_react.default.createElement(_splashPage.SplashPage, null);
  }

  return /*#__PURE__*/_react.default.createElement(_internal.PageLoader, {
    spec: normalizePage(NotFoundPage)
  });
};